// extracted by mini-css-extract-plugin
export default {"facetMenu":"Pw-z","fixed":"Qw-z","nonLayerdFacets":"Rw-z","productCount":"Sw-z","facetBack":"Tw-z","arrow":"Uw-z","facetClose":"Vw-z"};